/* eslint-disable @next/next/no-img-element */
import classNames from "classnames";

import style from "./style.module.scss";

export const Title = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div className={classNames(style.title, "text-gray-gray", className)}>
      {children}
    </div>
  );
};
